import { ThemeType } from '@/enums/themeType';
import { Setting } from '@starsoft/common/models';

export type ThemeStateProps = {
  type: ThemeType;
  setting?: Setting;
  isAdminView?: boolean;
  isAdminEmbed: boolean;
};

export enum ThemeActions {
  Set = 'theme/set',
  Settings = 'theme/settings-initialization',
  IsAdminView = 'theme/is-admin-view',
  IsAdminEmbed = 'theme/is-admin-embed',
}

export interface ThemeBasePayload<T extends ThemeActions, V = null> {
  type: T;
  payload: V;
}
export type SetThemePayload = ThemeBasePayload<ThemeActions.Set, ThemeType>;

export type SetSettingsPayload = ThemeBasePayload<
  ThemeActions.Settings,
  Setting
>;

export type SetIsAdminViewPayload = ThemeBasePayload<
  ThemeActions.IsAdminView,
  boolean
>;

export type SetIsAdminEmbedPayload = ThemeBasePayload<
  ThemeActions.IsAdminEmbed,
  boolean
>;

export type ThemeStatePayload =
  | SetThemePayload
  | SetSettingsPayload
  | SetIsAdminViewPayload
  | SetIsAdminEmbedPayload;
